import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KraIncentiveListAddComponent } from '../kra-incentive-list-add/kra-incentive-list-add.component';
import { Router } from '@angular/router';
import { RegistrationService } from 'src/app/shared/services/registration.service';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/shared/services/user.service';
import { AuthenticationService } from './../../../../../shared/services/authentication.service';

@Component({
  selector: 'app-kra-incentive-list',
  templateUrl: './kra-incentive-list.component.html',
  styleUrls: ['./kra-incentive-list.component.css']
})
export class KraIncentiveListComponent implements OnInit {
  EnableHumanMMU: any;
  is1962LiveStock: any;
  mvuLst: any = [];
  roleList: any = [];
  MVU: any = '-1';
  user_type_id: any = '';
  dtRender: boolean = true;
  dtOptions: any = {};
  lstGrid:any = [];
  start_date = new Date()
  max_date = new Date()
  selectedMMU: any;
  isEnableSendMail: boolean = false;


  constructor(
    private regService: RegistrationService
    , protected toastr: ToastrService
    , private modalService: NgbModal
    , public activeModal: NgbActiveModal
    , private formBuilder: FormBuilder
    , private datePipe: DatePipe
    , public changeDetection: ChangeDetectorRef
    , public router: Router
    , private userService: UserService
    , private datepipe:DatePipe
    , private AuthenticationService : AuthenticationService
    , public http :HttpClient
  ) { 
    const nav = this.router.getCurrentNavigation();
  // this.MVU = nav?.extras?.state?.['mvuId'] || '';
  if(nav?.extras?.state){
  this.MVU = nav?.extras?.state?.['selectedMMU'] || '-1';
  this.start_date = new Date(nav?.extras?.state?.['selectedDate']);
  }
  
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 15,
      dom: 'Bfrtip',
      processing: true,
      buttons: [

        {
          extend: 'excelHtml5',
          title: 'Incentive & Penalty Management_list',
          exportOptions: { columns: ':visible:not(:first-child)' }
        },

        // {
        //     // extend: 'pdfHtml5',
        //     title: 'Data export'
        // }
      ]

    };
    this.getFeaturePermission();
    this.getMvuList();
    this.LoadData()
 
  }
  getFeaturePermission() {
    // setTimeout(() => {
    var featureList: any = JSON.parse(localStorage.getItem('featuresList')) || [];
    for (let i = 0; i < featureList.length; i++) {
      if (featureList[i].feature_id.feature_name == "EnableHumanMMU") {

        this.EnableHumanMMU = featureList[i].patient;
      }
      if (featureList[i].feature_id.feature_name == "1962LiveStock") {

        this.is1962LiveStock = featureList[i].patient;
      }
      if (featureList[i].feature_id.feature_name == "EnableSendMail") {

        this.isEnableSendMail = featureList[i].patient;
      }
    }
    // }, 1500);
  }
  getMvuList() {
    let payload =
    {
      "state_id": this.is1962LiveStock ? 121 : sessionStorage.stateId,
      "district_id": -1,
      "mandal_id": -1,
      "village_id": -1
    }
    this.regService.post(`mvu/mvuteam/getallmvusbylocation`, payload).subscribe({
      next: res => {
        if (res.status == 'OK') {
           this.mvuLst = (res.data ?? []).sort((a: any, b: any) =>
          (a.mvu_name || '').localeCompare(b.mvu_name || '')
        );
           
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }
  getUserRole() {
    this.regService.get(`mvu/employee-penalty/getmappedusers/${this.MVU}`).subscribe({
      next: res => {
        if (res.status == 'OK') {
          this.roleList = res.data ?? []
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }
  LoadData() {
    // if(this.MVU === null || this.MVU === '' || this.MVU === undefined){
    //   this.toastr.info(`Please select ${this.EnableHumanMMU ? 'MMU' : 'MVU'}`)
    //   return
    // }
    this.lstGrid = [];
    this.dtRender = false;
    let payLoad = {
    "mvu_id":[this.MVU || -1],
    "from_date":  this.datePipe.transform(new Date(this.start_date.getFullYear(), this.start_date.getMonth(), 1), 'yyyy-MM-dd')
    }
    this.regService.post(`mvu/employee-incentives/getmmuamount`, payLoad).subscribe({
      next: res => {
        if (res.status == 'OK') {
          this.lstGrid = res.data ?? []
          this.dtRender = true
          // this.toastr.success(res.message)

        } else {
          let errMsg: string = res.message;
          this.dtRender = true
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.dtRender = true
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });

  }

  ExportExcel(){
    let date = this.datePipe.transform(new Date(this.start_date.getFullYear(), this.start_date.getMonth(), 1), 'yyyy-MM-dd')
    let date1 = this.datePipe.transform(new Date(this.start_date.getFullYear(), this.start_date.getMonth(), 1), 'dd-MM-yyyy')
    this.AuthenticationService.getTemplate(`mvu/employee-incentives/getmmuusersdatainexcel/${date}`,`All MMU_User_Incentives_Deductions_${date1} ` )
  }

  openModal(item:any) {
      let mvuId :any = ''
      let reportDate=new Date()
    if(item){
      mvuId = item.mvu_id
      reportDate = new Date(item.report_date)
    }
    if(this.MVU === '' || this.MVU === null || this.MVU === undefined){
      this.selectedMMU = -1
    }else{
      this.selectedMMU = this.MVU 
    }
    this.router.navigate(['home/kra/kraadd'], {
    state: { mvuId: mvuId ,selectedMMU : this.selectedMMU ,selectedDate : this.start_date, reportDate : reportDate }
  });

  }

  sendMail(){
    if(this.MVU === null || this.MVU === '' || this.MVU === undefined){
      this.toastr.info(`Please select ${this.EnableHumanMMU ? 'MMU' : 'MVU'}`)
      return
    }else{
    let date = this.datePipe.transform(new Date(this.start_date.getFullYear(), this.start_date.getMonth(), 1), 'yyyy-MM-dd')
  this.http.get(
  `notifications/sendmailformmuusers/${this.MVU}/${date}?TENANT_ID=${sessionStorage.TENANT_ID}`,
  { responseType: 'text' }
).subscribe({
  next: (res: string) => {
    console.log('API Response:', res);

    if (res?.trim() === 'Email Sent') {
      this.toastr.success("Email Sent Successfully");
    } else {
      this.toastr.error(res || 'Mail sending failed');
    }
  },
  error: (err) => {
    console.error(err);
    this.toastr.error('Server error while sending mail');
  }
});
    }
   

  }


}
